import React from 'react';
import PropTypes from 'prop-types';

const Gamme = ({ title }) => {
  return (
    <div style={{ padding: '30px 0 30px 0' }}>
      <center>
        <h3 style={{ fontWeight: 'bold', marginBottom: 20 }}>{title}</h3>
      </center>
    </div>
  );
};

Gamme.propTypes = {
  title: PropTypes.string.isRequired,
};

export default Gamme;



// WEBPACK FOOTER //
// ./src/components/Main/brand/Gamme.js